import Feed from './activity_feed'

export default Feed